module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/heart-3fc2ccf537dd69d87a1f6d92e90d4a67.png";